var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseConsultation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-sign-out",
    d: "M12,4a8,8,0,1,0,6.27,12.96.6.6,0,1,0-.941-.745,6.8,6.8,0,1,1,0-8.43.6.6,0,1,0,.941-.745A7.986,7.986,0,0,0,12,4Zm4.994,4.994a.6.6,0,0,0-.418,1.03L17.951,11.4,9.8,11.392a.6.6,0,1,0,0,1.2l8.153.007-1.377,1.377a.6.6,0,1,0,.849.849l2.4-2.4a.6.6,0,0,0,0-.848l-2.4-2.4A.6.6,0,0,0,16.994,8.994Z",
    transform: "translate(-4 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseConsultation);
export default __webpack_public_path__ + "static/media/closeConsultation.f6412dbbd75ea039120650ea71557f16.svg";
export { ForwardRef as ReactComponent };